// relative
import { apiSliceV2 } from '../../apiSlice';

export const dataApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['DataSeries'],
  endpoints: (builder) => ({
    getData: builder.query({
      query: (args) => {
        const { from, to, unitId, datatype, unitTypeInputId, aggregateType } =
          args;
        return {
          url: `/Data?orderby=Timestamp&Start=${from}&End=${to}&UnitId=${unitId}&AggregateType=${aggregateType}&DataType=${datatype}&UnitTypeInputId=${unitTypeInputId}&top=10000`,
          method: 'GET',
        };
      },
      providesTags: ['DataSeries'],
      keepUnusedDataFor: 5,
    }),
  }),
});
export const { useGetDataQuery, useLazyGetDataQuery } = dataApiSlice;
